import {Card, Flex} from '@sanity/ui'
import {styled} from 'styled-components'

export const CardOverlay = styled(Card)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const FlexContainer = styled(Flex)`
  height: 100%;
`
